(function () {
    'use strict';

    function initializeSearchPlaceholder() {
        var input = document.getElementById('header-search-input');
        if (!input || input.getAttribute('data-search-placeholder-ready') === '1') {
            return;
        }

        var phrases;
        try {
            phrases = JSON.parse(input.getAttribute('data-search-phrases') || '[]');
        } catch (error) {
            return;
        }
        if (!Array.isArray(phrases) || !phrases.length || phrases.some(function (phrase) {
            return typeof phrase !== 'string' || !phrase;
        })) {
            return;
        }

        input.setAttribute('data-search-placeholder-ready', '1');
        var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var prefix = input.getAttribute('data-search-prefix') || '';
        var original = input.getAttribute('placeholder') || '';
        var phraseIndex = 0;
        var position = 0;
        var erasing = false;
        var timer = null;

        function blocked() {
            return document.hidden || motion.matches || document.activeElement === input || input.value !== '';
        }

        function stop() {
            window.clearTimeout(timer);
            timer = null;
            position = 0;
            erasing = false;
            input.setAttribute('placeholder', original);
        }

        function tick() {
            if (blocked()) {
                stop();
                return;
            }

            var phrase = phrases[phraseIndex];
            position += erasing ? -1 : 1;
            input.setAttribute('placeholder', prefix + phrase.slice(0, position));
            var delay = erasing ? 45 : 95;

            if (position === phrase.length) {
                erasing = true;
                delay = 2300;
            } else if (position === 0) {
                erasing = false;
                phraseIndex = (phraseIndex + 1) % phrases.length;
                delay = 350;
            }

            timer = window.setTimeout(tick, delay);
        }

        function refresh() {
            stop();
            if (!blocked()) {
                timer = window.setTimeout(tick, 1400);
            }
        }

        ['focus', 'blur', 'input', 'change', 'search'].forEach(function (event) {
            input.addEventListener(event, refresh);
        });
        document.addEventListener('visibilitychange', refresh);
        window.addEventListener('pagehide', stop);
        window.addEventListener('pageshow', refresh);
        if (motion.addEventListener) {
            motion.addEventListener('change', refresh);
        } else {
            motion.addListener(refresh);
        }
        refresh();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSearchPlaceholder);
    } else {
        initializeSearchPlaceholder();
    }
}());
